import ExternalLink from "../../components/ExternalLink"
import { VersionFolder, VersionStr } from "../../logic/Versions"

type LicenseFileLocationsProps = {
    description?: string
    os: string,
    isContainer: boolean
}

const defaultLocation :  Record<string, JSX.Element> = {
    'windows': <><code>C:\gurobi, C:\gurobi{VersionFolder}</code> (for {VersionStr}), or your home directory</>,
    'linux': <><code>/opt/gurobi, /opt/gurobi{VersionFolder}</code> (for {VersionStr}), or your home directory</>,
    'macos': <><code>/Library/gurobi, /Library/gurobi{VersionFolder}</code> (for {VersionStr}), or your home directory</>
}

const LicenseFileLocations = ({ description, os, isContainer }: LicenseFileLocationsProps) => <>
    Store your {description ?? 'license file'} as <code>gurobi.lic</code> in {isContainer ? 'your application folder' : defaultLocation[os]}.
    {!isContainer && <> Note that if you place the license file in your home directory, the license will only be available for your account on the computer.</>} If
    you're installing multiple Gurobi components on different operating systems, refer to the <ExternalLink href="https://support.gurobi.com/hc/en-us/articles/360013417211-Where-do-I-place-the-Gurobi-license-file-gurobi-lic-">default license locations</ExternalLink> per operating system.
</>
export default LicenseFileLocations